"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchResult;
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SVBSearchResult(props) {
  const {
    categoryType,
    categoryTypeLink,
    resultLimit,
    cardOptions,
    cardJson
  } = props;
  const [mounted, setMounted] = (0, _react.useState)(false);
  const [data, setData] = (0, _react.useState)([]);
  const [limitCards, setLimitcards] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    setData(cardJson);
    setLimitcards(resultLimit || 2);
    setMounted(true);
  }, []);
  if (!mounted) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-5 result-type-group"
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
    type: "sub-heading",
    variant: "small mb-4"
  }, categoryType), /*#__PURE__*/_react.default.createElement("div", {
    className: "cards"
  }, data && data.map((item, i) => {
    if (i < limitCards) {
      return /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBCard, {
        key: i,
        extraClasses: "h-auto mb-4 ".concat(item.searchType ? item.searchType : ""),
        cardIcon: item.cardIcon,
        title: item.title,
        description: item.description,
        categories: item.categories,
        link: item.resourceLink,
        cardOptions: cardOptions ? cardOptions : {
          cardClickable: true,
          cardTypes: "search"
        }
      });
    }
  })), data && data.length > limitCards && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex show-all justify-content-center w-100"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: categoryTypeLink || "apis/docs-home"
  }, "Show All", /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-arrow-right ps-1"
  }))));
}
SVBSearchResult.propTypes = {
  categoryType: _propTypes.default.string,
  categoryTypeLink: _propTypes.default.string,
  resultLimit: _propTypes.default.number
};